import * as React from 'react';

import { DeveloperInfo } from '../../../../components/BottomAuthorBlockNew';
import { CardSectionNew } from '../../../../components/CardSectionNew';
import { PhonesContainer } from '../../../AsideContacts/PhonesContainer';
import { CallBackButtonContainer } from '../../../CallBackButton';
import { useDeveloperProps } from './hooks';

export const DeveloperInfoContainer: React.FC = () => {
  const props = useDeveloperProps();

  if (!props) {
    return null;
  }

  return (
    <CardSectionNew>
      <DeveloperInfo
        contactButton={<PhonesContainer size="XS" />}
        callButton={<CallBackButtonContainer size="XS" placeType="agent_block" />}
        {...props}
      />
    </CardSectionNew>
  );
};
